export class User {
	id: string;
	enterprises: string[];
	login?: string;
	name?: string;
	photoURL?: string;
	password: string;
	firstName: string;
	lastName: string;
	status: number;
	createdTime: string;
	updatedTime: string;
	createdUser: string;
	updatedUser: string;
	createdPgm: string;
	updatedPgm: string;
	constructor() {
		this.firstName = '';
		this.login = '';
	}
	fromGoogle(userGoogle) {
		for (var i = 0; i < userGoogle.length; i++) {
			console.log(userGoogle[i].$key);
			if (userGoogle[i].$key == 'uid') {
				this.id = userGoogle.uid;
			} else if (userGoogle[i].$key == 'email') {
				this.login = userGoogle.email;
			} else if (userGoogle[i].$key == 'displayName') {
				this.name = userGoogle.displayName;
			} else if (userGoogle[i].$key == 'photoURL') {
				this.photoURL = userGoogle.photoURL;
			}
		}
		this.id = userGoogle.uid;
		this.login = userGoogle.email;
		this.name = userGoogle.displayName;
		this.photoURL = userGoogle.photoURL;
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/.modal/user.ts